import { Injectable } from '@angular/core';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';
import { ILightWeightObject, ILightWeightObjectCollection } from '@fi-shared/models';
import { SideListOptionType } from '@fi-shared/types';
import { IMediaBankFile } from '@fi-shared/media-bank';
import { MediaBankListParameter } from '@fi-shared/media-bank/media-bank-list-parameter';
import { IItemsListDataFetchResult, IItemsListParameterBase } from '@fi-shared/fi-items-list/fi-items-list';
import { ILightWeightTag } from '@fi-shared/fi-tag2/fi-tag2';

@Injectable()
export class FiMediaBankService {
    constructor(private fiBackend: FiBackendService) {}

    saveMediaBankFiles(mediaBankFiles: IMediaBankFile[]) {
        return this.fiBackend.fetchDataPost('MediaBank/MediaBank/SaveMediaBankFiles', mediaBankFiles);
    }

    getMediaBankFile(id: number, isViewMode: boolean) {
        return this.fiBackend.fetchData<IMediaBankFile>(
            `MediaBank/MediaBank/GetMediaBankFile/${id}?isViewMode=${isViewMode}`,
        );
    }

    saveMediaBankFileDownloadInfo(mediaBankFileId: number) {
        this.fiBackend.fetchDataPost(
            `MediaBank/MediaBank/SaveMediaBankFileDownloadInfo/${mediaBankFileId}`,
            undefined,
            {
                supressErrorMessage: true,
            },
        );
    }

    getLightWeightMediaBankFiles(sideListOption: SideListOptionType, tagId?: number) {
        const url = `MediaBank/MediaBank/GetLightWeightMediaBankFiles?sideListOption=${sideListOption || SideListOptionType.SharedWithMe}&tagId=${tagId || 'null'}`;
        return this.fiBackend.fetchData<IMediaBankFile[]>(url);
    }

    saveMediaBankFile(mediaBankFile: IMediaBankFile, isTemporary?: boolean) {
        return this.fiBackend.fetchDataPost<number>(
            `MediaBank/MediaBank/SaveMediaBankFile?isTemporary=${!!isTemporary}`,
            mediaBankFile,
        );
    }

    getMediaBankFileTags() {
        return this.fiBackend.fetchData<ILightWeightTag[]>('MediaBank/MediaBank/GetMediaBankFileTags');
    }

    getMediaBankFilesListData(parameter: IItemsListParameterBase) {
        return this.fiBackend.fetchDataPost<IItemsListDataFetchResult<IMediaBankFile>>(
            'MediaBank/MediaBank/GetMediaBankFilesListData',
            parameter,
        );
    }

    getMediaBankFiles(parameter: MediaBankListParameter) {
        return this.fiBackend.fetchDataPost<IMediaBankFile[]>('MediaBank/MediaBank/GetMediaBankFiles', parameter);
    }

    getMediaBankFilesCount(parameter: MediaBankListParameter) {
        return this.fiBackend.fetchDataPost<number>('MediaBank/MediaBank/GetMediaBankFilesCount', parameter);
    }

    getLightWeightObjectsForLocalSearch(
        parameter: MediaBankListParameter,
        v2?: boolean,
    ): Promise<ILightWeightObjectCollection> {
        return this.fiBackend.fetchDataPost<ILightWeightObjectCollection>(
            `MediaBank/MediaBank/GetLightWeightObjectsForLocalSearch?v2=${!!v2}`,
            parameter,
        );
    }
}
